/**
 * Anne Klein Horizon contrast control (toggle/storage from LottoSport.com).
 * Storage key ada-contrast-mode so shopper choice is consistent across WHP brands.
 * Sets html[data-contrast-mode] / [data-forced-colors] / [data-reduced-transparency].
 * Token CSS (snippets/ak-ada-contrast.liquid) is a LIGHT boost for AK, not Lotto's
 * black invert: black page wash hid header actions and broke PLP/search.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ada-contrast-mode';
  var CONTRAST_QUERIES = ['(prefers-contrast: more)', '(prefers-contrast: high)'];
  var FORCED_COLORS_QUERY = '(forced-colors: active)';
  var REDUCED_TRANSPARENCY_QUERY = '(prefers-reduced-transparency: reduce)';

  function root() {
    return document.documentElement;
  }

  function prefersMoreContrast() {
    return CONTRAST_QUERIES.some(function (q) {
      return window.matchMedia(q).matches;
    });
  }

  function announce(on) {
    var live = document.getElementById('ak-ada-contrast-live');
    if (!live) return;
    live.textContent = '';
    window.requestAnimationFrame(function () {
      live.textContent = on ? 'High contrast on' : 'High contrast off';
    });
  }

  function syncOsAttributes() {
    var html = root();
    if (window.matchMedia(FORCED_COLORS_QUERY).matches) {
      html.setAttribute('data-forced-colors', 'active');
    } else {
      html.removeAttribute('data-forced-colors');
    }
    if (window.matchMedia(REDUCED_TRANSPARENCY_QUERY).matches) {
      html.setAttribute('data-reduced-transparency', '');
    } else {
      html.removeAttribute('data-reduced-transparency');
    }
  }

  function applyMode(on, opts) {
    var html = root();
    var silent = opts && opts.silent;
    if (html.getAttribute('data-forced-colors') === 'active') {
      html.removeAttribute('data-contrast-mode');
      return;
    }
    if (on) {
      html.setAttribute('data-contrast-mode', 'on');
    } else {
      html.removeAttribute('data-contrast-mode');
    }
    document.querySelectorAll('.ada-contrast-toggle, .ak-ada-contrast-toggle').forEach(function (btn) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('active', on);
      btn.setAttribute('aria-label', on ? 'High contrast on' : 'High contrast');
    });
    if (!silent) announce(on);
  }

  function currentOn() {
    return root().getAttribute('data-contrast-mode') === 'on';
  }

  function initFromStorage() {
    syncOsAttributes();
    if (root().getAttribute('data-forced-colors') === 'active') {
      applyMode(false, { silent: true });
      return;
    }
    var saved = localStorage.getItem(STORAGE_KEY);
    var on = saved === 'on' || (saved == null && prefersMoreContrast());
    applyMode(on, { silent: true });
  }

  function toggle() {
    if (root().getAttribute('data-forced-colors') === 'active') return;
    var next = !currentOn();
    if (next) {
      localStorage.setItem(STORAGE_KEY, 'on');
    } else {
      localStorage.setItem(STORAGE_KEY, 'off');
    }
    applyMode(next);
  }

  CONTRAST_QUERIES.forEach(function (q) {
    var mq = window.matchMedia(q);
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        if (localStorage.getItem(STORAGE_KEY)) return;
        applyMode(prefersMoreContrast(), { silent: true });
      });
    }
  });

  var forcedMq = window.matchMedia(FORCED_COLORS_QUERY);
  if (forcedMq.addEventListener) {
    forcedMq.addEventListener('change', initFromStorage);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.ada-contrast-toggle, .ak-ada-contrast-toggle');
    if (!btn) return;
    event.preventDefault();
    toggle();
  });

  window.AK_Contrast = {
    toggle: toggle,
    apply: applyMode,
    isOn: currentOn,
  };

  initFromStorage();
})();
